module.exports = __webpack_public_path__ + "img/office_interview_passed.21109599.svg";